
import CryptoJS from 'crypto-js';
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';
import VueElementLoading from 'vue-element-loading';
import moment from "moment";
import TripServices from '../../services/firstAndLastmilemanagement.service';
import Util from './../../../shared/util/util';
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import CONSTANT from './../../../shared/constants/constant';
import Pagination from './../../../shared/components/pagination';
export default {
  name: 'basicinformation',
  components: {
    highcharts:Chart,
    // HighchartsSolidGauge,
    VueElementLoading,
    Highcharts,
    TripServices,
    CustomExpandableTable,
    Util,
    Pagination,
    moment
  },

  data() {
    return {
      accordianTab: {
        1: false,
        2: false,
        3: false
      },
        isLoading:false,
        Moredetailscount:false,
        counters:"",
        bookingmethod: "",
        originhub:"",
        donut:{
          chart: {
            type: 'pie',
            height: 360
          },
          title: {
            text: 'FM Shipment Status'
          },
          tooltip: {
            pointFormat: '<span style="color:black">{point.name}</span>: <b>{point.count}</b> of total 100 <br/>'
         },
          plotOptions: {
            pie: {
              size:'80%',
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y} ',
                distance: -50,
              },
              events: {
                click: (e) =>{
                   this.donutClickFunction(e)
                }
              },
              showInLegend: true
            }
          },
          series: [{
            name: 'Percentage',
            colorByPoint: false,
            // innerSize: '75%',
            data: [{
              name: 'Allocated<br>SR',
              y: 25,
              count:25,
              color: '#16A085'
            }, {
              name: 'OFP',
              y: 15,
              count:15,
              color:'#F39C12'
            }, {
              name: 'Picked',
              y: 25,
              count:25,
              color:'#e48996'
            }, {
              name: 'NPR',
              y: 35,
              count:35,
              color:'#803D9B'
            }]
          }]
        },

        donut_variant:{
          chart: {
            type: 'pie',
            height: 360
          },
          title: {
            text: 'LM Shipment Status'
          },
          subtitle:{
            text : 'Total Count : 100'
          },
          tooltip: {
            pointFormat: '<span style="color:black">{point.name}</span>: <b>{point.count}</b> of total 100 <br/>'
         },
          plotOptions: {
            pie: {
              size:'80%',
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y} ',
                distance: -50,
              },
              events: {
                click: (e) =>{
                   this.donutClickFunction(e)
                }
              },
              showInLegend: true
            }
          },
          series: [{
            name: 'Percentage',
            colorByPoint: false,
            // innerSize: '75%',
            data: [{
              name: 'Allocated<br>SR',
              y: 70,
              count:70,
              color: '#16A085'
            }, {
              name: 'OFD',
              y: 5,
              count:5,
              color:'#F39C12'
            }, {
              name: 'Delivered',
              y: 12,
              count:12,
              color:'#e48996'
            }, {
              name: 'NDR',
              y: 13,
              count:13,
              color:'#803D9B'
            }]
          }]
        },
        yesterdaydate:"",
        hubid:0,
        pendingforclosuer:{ tripcreated: 0, tripstarted: 0, ofp:0, ofd:0, picked:0, undelivered:0, delivered:0, closed:0},
        selectedtab: '',
        selectedtabvalue: '',
        tableColumn: [],
        tableItems: [],
        offset:0,
        lastrefreshed:'',
        interval:"",
        detailsinterval:"",
        todayperformance: {tripcreated : 0, tripstart: 0, tripclose: 0, fmallocation: 0, fmofp: 0, fmpicked: 0, fmnpr: 0, lmallocation: 0, lmofd: 0, fmdelivered: 0, lmndr: 0, pendingforclosure:0},
        ytdperformance: { trip: 0, picked: 0, delivered: 0},
        nextcouseaction: "",
        nextaction: {
          tripdatacreated : "Please out-scan AWB and start the trips.",
          tripdatastart : "Please in-scan awb's and close trip.",
          tripdataclosed : "Please perform AWB verification.",
          awbdataofp : "Please in-scan AWB's received and close the trip.",
          awbdataofd : " Please close the trip once AWB are delivered.",
          awbdatapicked : "Please in-scan picked AWB and close the trip.",
          awbdataundelivered : "Please in-scan undelivered AWB and close trip.",
          awbdatadelivered : "Please close the trip.",
          todaytripdatacreated : "Please out-scan AWB and start the trips.",
          todaytripdatastart : "Please in-scan awb's and close trip.",
          todaytripdataclosed : "Please perform AWB verification.",
          todayallocationfirstmile : "Please start the FM trip.",
          todayawbdataofp : "Please in-scan AWB's received and close the trip",
          todayawbdatapicked : "Please scan document and close the trip.",
          todayawbdataunpicked : "Please close the trip.",
          todayallocationlastmile : "Please start the LM trip.",
          todayawbdataofd : "Please verify the documents and close the trip.",
          todayawbdatadelivered : "Please verify the documents and close the trip.",
          todayawbdataundelivered : "Please scan undelivered shipments and close the trip.",
          todaytripdatapendingclosure : "Please scan the AWBs and close the trip.",
		  badpoddatafirstmilepod : "View the bad POD ",
		  badpoddatalastmilepod : "Please upload the PODs again",
        },
		podperformance: {firstmilebadpod : 0, lastmilebadpod: 0},
        moredetails:"Count",
        tripDetails:"",
        totalPage: 0,
        totalCount:0,
        offset:0,
        currentPage: 1,
        pageLimit:CONSTANT.PER_PAGE_DATA,
        sorting: "desc",
		isReuploadImage:'',
		redirectTitle :'Redirect',
		userflag:true,
		cltcrm:'',
    awbdataforlastmilemoredetails:{},
    groupedArray:[],
    tableItemspartialawb:[],
    tempdata:[],
    showAWB:false
      }
  },

  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.hubid = userdetail.hubID[0];
    this.userName = userdetail.email;
    this.userRoleFlag = (userdetail.rolename[0] == "Hub Executive" || userdetail.rolename[0] == "Hub Incharge" || userdetail.rolename[0] == "Hub Manager" ) ? 1:2;
	if(userdetail.rolename[0] == 'CLT/CRM'){
	  this.userflag = false;	
	}
    if(this.userRoleFlag == 1){
      this.originhub = userdetail.hubID[0];
    }
    var date = new Date();
    date.setDate(date.getDate() - 1);
    this.yesterdaydate =  moment(date).tz('Asia/Kolkata').format('YYYY-MM-DD');

    this.accordianTab[1] = true;
    
    this.getFLMDashboardCount();
	this.getFLMBadPODCount();
    this.autorefreshcount()
  },
  async beforeDestroy(){
    clearInterval(this.interval);
    clearInterval(this.detailsinterval);
  },
  methods: {
    redirectTriplisting(){
	  if(this.selectedtab == 'badpoddata'){
		this.$router.replace({ path: "/reUploadPod"});
	  }else{
		this.$router.replace({ path: "/TripManagement", query: { TripFilterData: this.tripDetails } });
	  }	
   },
    barClickedFun(data) {
    //    this.$router.replace({ path: "/Booking", query: { BookingMethod: data.point.options.name } });
    },
    donutClickFunction(e) {
      document.getElementById('temp')
    //   this.$router.replace({ path: "/Booking", query: { BookingStatus: e.point.options.name } });
    },
    closeMoreDetails(){
      this.Moredetailscount = false;
      this.sorting ='desc';
      this.totalPage = 0;
      this.totalCount =0;
      this.offset = 0;
      this.currentPage = 1;
    },
    closeMoreDetailsPartialAWB(){
      this.showAWB=false
    },
    openMoreDetailsCount(tab, value){
      this.isLoading=true,
      this.totalPage = 0;
      this.totalCount =0;
      this.offset = 0;
      this.currentPage = 1;
	  let label
      if(value == "ofd" || value == "ofp" || value == "picked" || value == "undelivered" || value == "firstmile" || value == "unpicked" || value == "lastmile" || value == "delivered"){
        var on = document.getElementById("redirectbutton");
        on.style.display = "none";
      }else{
        var on = document.getElementById("redirectbutton");
        on.style.display = "block";
      }
      this.tripDetails = {};
     if(tab == "tripdata" || tab == "awbdata") {
      this.tripDetails['tripStatus'] = value;
     }else{
      if (value == "pendingclosure") {
        this.tripDetails['tripStatus'] = "start";
        this.tripDetails['todaydate'] = "true";
       } else {
         this.tripDetails['tripStatus'] = value;
         this.tripDetails['todaydate'] = "true";
       }
     }
     
      this.triplistingStatus = value;
      this.selectedtab = tab;
      this.selectedtabvalue = value;
	  if(this.selectedtab == 'badpoddata'){
		this.redirectTitle = "Redirect to POD Upload Dashboard "
		this.sorting = null
		this.getFMLMPODTabDetails();
		label = "Bad POD Count"
		this.moredetails = label;
		this.nextcouseaction = this.nextaction[tab+value];
	  }else{
		this.redirectTitle = "Redirect to trip listing page"
		this.getFLMTabDetails();
		label = `${this.selectedtabvalue} Count`.charAt(0).toUpperCase() + `${this.selectedtabvalue} Count`.slice(1)
		label = this.selectedtab == 'tripdata'? 'Trip ' + label : label 
		this.moredetails = label;
		this.nextcouseaction = this.nextaction[tab+value];
	  }
      this.Moredetailscount = true;
    //  this.tableColumn=[];
    //  this.tableItems=[];
      this.sorting ='desc';
      this.isLoading=false
    },
    async getFLMDashboardCount(){
      try {
        this.isLoading = true;
        let InputPayload = {};
        if (this.hubid!="") {
          InputPayload.hubid = this.hubid;
        }
        let result = await TripServices.getFLMDashboardCount(InputPayload);
        this.isLoading = false;
        if(result.data.code == 200) {
          this.pendingforclosuer.tripcreated = result.data.data.createdtrip;
          this.pendingforclosuer.tripstarted = result.data.data.start;
          this.pendingforclosuer.ofp = result.data.data.ofp;
          this.pendingforclosuer.ofd = result.data.data.ofd;
          this.pendingforclosuer.picked = result.data.data.picked;
          this.pendingforclosuer.delivered = result.data.data.delivered;
          this.pendingforclosuer.closed = result.data.data.closed;
          this.todayperformance.tripcreated = result.data.data.todayperformance.tripcreated; 
          this.todayperformance.tripstart= result.data.data.todayperformance.tripstart; 
          this.todayperformance.tripclose=result.data.data.todayperformance.tripclose; 
          this.todayperformance.fmallocation=result.data.data.todayperformance.fmallocation; 
          this.todayperformance.fmofp=result.data.data.todayperformance.fmofp; 
          this.todayperformance.fmpicked=result.data.data.todayperformance.fmpicked; 
          this.todayperformance.fmnpr=result.data.data.todayperformance.fmnpr; 
          this.todayperformance.lmallocation=result.data.data.todayperformance.lmallocation; 
          this.todayperformance.lmofd= result.data.data.todayperformance.lmofd; 
          this.todayperformance.fmdelivered= result.data.data.todayperformance.fmdelivered; 
          this.todayperformance.lmndr= result.data.data.todayperformance.lmndr;
          this.todayperformance.pendingforclosure= result.data.data.todayperformance.pendingforclosure;
          this.ytdperformance.trip= result.data.data.ytdperformance.trip;
          this.ytdperformance.picked= result.data.data.ytdperformance.picked;
          this.ytdperformance.delivered= result.data.data.ytdperformance.delivered;
        } else {
          this.pendingforclosuer.tripcreated = 0;
          this.pendingforclosuer.tripstarted = 0;
          this.pendingforclosuer.ofp = 0;
          this.pendingforclosuer.ofd = 0;
          this.pendingforclosuer.picked = 0;
          this.pendingforclosuer.undelivered =0;
          this.pendingforclosuer.closed = 0;
          this.todayperformance.tripcreated = 0; 
          this.todayperformance.tripstart= 0; 
          this.todayperformance.tripclose=0; 
          this.todayperformance.fmallocation=0; 
          this.todayperformance.fmofp=0; 
          this.todayperformance.fmpicked=0; 
          this.todayperformance.fmnpr=0; 
          this.todayperformance.lmallocation=0; 
          this.todayperformance.lmofd= 0; 
          this.todayperformance.fmdelivered= 0; 
          this.todayperformance.lmndr= 0;
          this.todayperformance.pendingforclosure=0;
          this.ytdperformance.trip= 0;
          this.ytdperformance.picked= 0;
          this.ytdperformance.delivered= 0;
        }
        this.lastrefreshed = moment().format('DD-MM-YYYY, h:mm:ss a')
      } catch (err) {
        console.log(err);
      }
    },
	async getFMLMPODTabDetails(){
	  try {
	    this.isLoading = true;
		let InputPayload = {};
		InputPayload.hubid = this.hubid
		InputPayload.orderby = 'desc'
    InputPayload.offset = this.offset
    InputPayload.limit=this.pageLimit
    InputPayload.queryType = '2'
		let result = await TripServices.getFLMDashboardpoddetails(InputPayload)
    		this.isLoading = false;
        if(result.data.code ==200){
			if(this.selectedtabvalue == 'firstmilepod'){
        this.totalCount=this.podperformance.firstmilebadpod
				this.setFMLMBadPODData(result.data.data)
			}else if(this.selectedtabvalue == 'lastmilepod'){
        this.totalCount= this.podperformance.lastmilebadpod
				this.setFMLMBadPODData(result.data.data)
			}
		}else{
			this.totalCount = 0
            this.tableItems = [];
		}
		if (this.totalCount < this.pageLimit) {
			this.totalPage = 1
		} else {
			this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
		}  
		if(this.selectedtab == 'badpoddata'){
			this.sorting = null
			this.tableColumn = ['Trip ID', 'AWB', 'AWB Status', 'No. Of MPS', "Bad POD reason", "Age (days)"]  	
		}
		
		this.isLoading = false;
	  } catch (error) {
		console.log("Error --",error)
		this.isLoading = false;
	  }
	},
    async getFLMTabDetails(){
      try {
        this.isLoading = true;
        let InputPayload = {};
        InputPayload.hubid = this.hubid;
        InputPayload.tab = this.selectedtab
        InputPayload.value = this.selectedtabvalue
        InputPayload.offset = this.offset;
        InputPayload.limit = this.pageLimit;
        InputPayload.orderby = this.sorting == 'desc' ? 'asc' : 'desc';
        let result = await TripServices.getFLMTabDetails(InputPayload);
        this.isLoading = false;
        if(result.data &&result.data.data && result.data.code == 200) {
          this.totalCount =result.data.data.count
          this.setFLMTabData(result.data.data.rows);
        } else{
          this.totalCount = 0
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }

        if(this.selectedtab == 'tripdata'  || this.selectedtab == 'todaytripdata' ){
          this.tableColumn = ['Trip ID', 'Trip Status', 'Assigned to : BA/SR Name', 'Open ODO reading', "Vehicle type", "Trip creation date", "Age (days)"]
        } else if(this.selectedtab == 'awbdata' || this.selectedtab == 'todayawbdata' || this.selectedtab == 'todayallocation'){
          this.tableColumn = ['Trip ID', 'AWB', 'AWB Status', 'No. Of MPS', "Total Weight", "Age (days)"]
        }
        this.isLoading = false;
        
      } catch (error) {
        console.log(error);
		this.isLoading = false;
      }
    },
	async getFLMBadPODCount(){
	  try {
		this.isLoading = true;
		let inputPayload = {}
		inputPayload.hubid = this.hubid
		inputPayload.orderby = 'desc',
    inputPayload.queryType = '1'
		let result = await TripServices.getPODCountDetails(inputPayload);
		if(result.data.code == 200){
		  this.podperformance.firstmilebadpod = result.data.data.FMCount
		  this.podperformance.lastmilebadpod = result.data.data.LMCount
		}
		this.isLoading = false;
	  } catch (error) {
		console.log(error);
		this.isLoading = false;
	  }	
	},
	setFMLMBadPODData(data){	
	  let set = (this.currentPage - 1) * this.pageLimit
	  let rset = (this.currentPage - 1) * this.pageLimit + this.pageLimit
	  if (this.selectedtab == 'badpoddata' && this.selectedtabvalue == 'firstmilepod') {
		this.tableItems = data.firstmileresult.rows.map((el)=>{
			return {
				'id':1,
				'Trip ID':el.tmstripid,
				'AWB':el.awb,
				'AWB Status': el.awbstatus, 
				'No. Of MPS':el.numberofmps,
				'Bad POD reason': data.firstmiledata[el.awb].toString(),
				'Age (days)': moment().diff(el.lastmodifieddate, 'days'),
			}
		})
		}else if(this.selectedtab == 'badpoddata' && this.selectedtabvalue == 'lastmilepod'){
        this.groupedArray = data.lastmileresult.rows.reduce((acc, obj) => {
        const foundIndex = acc.findIndex((group) => group[0].awb === obj.awb);
        if (foundIndex !== -1) {
          acc[foundIndex].push(obj);
        } else {
          acc.push([obj]);
        }
        return acc;
      }, []);
      this.tempdata=data
			this.tableItems = this.groupedArray.map((el)=>{
				return {
					'id':1,
					'Trip ID':el[0].tmstripid,
					'AWB':el[0].awb,
					'AWB Status': el[0].awbstatus, 
					'No. Of MPS':el[0].numberofmps,
					'Bad POD reason':data.lastmiledata[el[0].awb].toString(),
					'Age (days)': moment().diff(el[0].lastmodifieddate, 'days'),
          'count':el.length
				}
			})
		}    
	},
 filterObjectsByUniqueProperty(array, propertyName) {
    const uniqueValues = [];
    return array.filter(obj => {
      if (uniqueValues.indexOf(obj[propertyName]) === -1) {
        uniqueValues.push(obj[propertyName]);
        this.awbdataforlastmilemoredetails[obj[propertyName]].push(obj)
        return true;
      }
      return false;
    });
  },
    setFLMTabData(data) {
      if (this.selectedtab == 'tripdata' || this.selectedtab == 'todaytripdata') {
        this.tableItems = data.map((el)=>{
          return {
              'id':el.id,
              'Trip ID':el.tmstripid,
              'Trip Status':el.tripstatus,
              'Trip creation date': Util.displayDateTimeFormat(el.tripcreateddate), 
              'Assigned to : BA/SR Name':el.username,
              'Vehicle type':el.vehiclevendortype,
              'Age (days)': moment().diff(el.tripcreateddate, 'days'),
              'Open ODO reading': el.openkm
          }
        })
      } else if(this.selectedtab == 'awbdata' || this.selectedtab == 'todayawbdata' || this.selectedtab == 'todayallocation'){
        this.tableItems = data.map((el)=>{
          let age;
          // if (this.selectedtabvalue == 'ofp' || this.selectedtabvalue == 'ofd') {
          //   age = el["cargotripawbs.ofpofddatetime"] ? moment().diff(el["cargotripawbs.ofpofddatetime"], 'days') : moment().diff(el["cargotripawbs.lastmodifieddate"], 'days');
          // } else if ( this.selectedtabvalue == 'picked' || this.selectedtabvalue == 'delivered') {
          //   age = el["cargotripawbs.pickupdeliverydatetime"] ? moment().diff(el["cargotripawbs.pickupdeliverydatetime"], 'days') : moment().diff(el["cargotripawbs.lastmodifieddate"], 'days');
          // } else {
          age = moment().diff(el["cargotripawbs.lastmodifieddate"], 'days');
          // }
          return {
              'id':el.id,
              'Trip ID':el.tmstripid,
              'AWB':el["cargotripawbs.awb"],
              'AWB Status': el["cargotripawbs.awbstatus"], 
              'No. Of MPS':el["cargotripawbs.numberofmps"],
              'Age (days)':age,
              'Total Weight':el["cargotripawbs.totalwt"]
          }
        })
      }
      // this.sorting == 'asc' ? this.tableItems.sort((a,b) => a['Age (days)'] - b['Age (days)']) : this.tableItems.sort((a,b) => b['Age (days)'] - a['Age (days)'])
    },
    getCustomTableEvent(event) {
       if (event.actionType == "sorting") {
        // event.id == 'asc' ? this.tableItems.sort((a,b) => a['Age (days)'] - b['Age (days)']) : this.tableItems.sort((a,b) => b['Age (days)'] - a['Age (days)'])
        this.sorting = event.id;
        this.totalPage = 0;
        this.totalCount =0;
        this.offset = 0;
        this.currentPage = 1;
		if(this.selectedtab == 'badpoddata'){
			this.getFMLMPODTabDetails();
		}else{
			this.getFLMTabDetails();
		}
        //this.getFLMTabDetails()
		//this.getFMLMPODTabDetails()
       }
       if (event.actionType == "viewAWB") {
        this.tableItemspartialawb = this.groupedArray[event.id].map((el)=>{
          return {
            'id':1,
            'Trip ID':el.tmstripid,
            'AWB':el.awb,
            'AWB Status': el.awbstatus, 
            'No. Of MPS':el.numberofmps,
            'Bad POD reason':  this.tempdata.lastmiledata[el.awb].toString(),
            'Age (days)': moment().diff(el.lastmodifieddate, 'days'),
          }
        })
        this.showAWB = true;
      }
    },
    autocallapi() {
      if (this.Moredetailscount ==true) {
        this.getFLMTabDetails()
		this.getFMLMPODTabDetails()
      }
      else{
        this.getFLMTabDetails()
		    this.getFLMBadPODCount()
      }
    },
    autorefreshcount() {
      this.interval = setInterval(() => this.manualrefresh(), 60000);
      this.detailsinterval= setInterval(() => this.autocallapi(), 60500);
    },
    manualrefresh()
    {
       this.getFLMBadPODCount();
       this.getFLMDashboardCount();
    },
    onPageChange(page) {
     this.isLoading=true,
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getFLMTabDetails();
	  this.getFMLMPODTabDetails()
    this.isLoading=false
    },
    
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/flmdashboard/flmdashboard.component.js